import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCta from './components/FloatingCta';

import Forside from './pages/Forside';
import Ydelser from './pages/Ydelser';
import YdelseDetail from './pages/YdelseDetail';
import Referencer from './pages/Referencer';
import ReferenceDetail from './pages/ReferenceDetail';
import OmOs from './pages/OmOs';
import Kontakt from './pages/Kontakt';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-slate-50 text-slate-900 selection:bg-slate-900 selection:text-white">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/ydelser" element={<Ydelser />} />
          <Route path="/ydelser/:slug" element={<YdelseDetail />} />
          <Route path="/referencer" element={<Referencer />} />
          <Route path="/referencer/:slug" element={<ReferenceDetail />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <FloatingCta />
    </div>
  );
}

export default App;
